import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 54px;

  img {
    width: 250px;
    @media (max-width: 768px) {
      width: 200px;
    }
  }

  h1 {
    font-size: 18px;
    text-align: center;

    @media (max-width: 480px) {
      font-size: 16px;
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 850px;
    padding: 24px;

    @media (max-width: 480px) {
      max-width: 80vw;
    }
  }
`;
